import React, { Component } from 'react';
import * as THREE from 'three';


/**
 *  width, height - canvas width, height
 *  top, left - canvas top, left
 *  zIndex - canvas zIndex
 * 
 *  textureUrl
 *  framwWidth framwHeight
 * 
 *  textureX, textureY - где находится текстура
 *  nowFrame
 * 
 */

export class TextureCropper extends Component {

    uId = Math.floor((Math.random() * 2000));

    uAddedColorR = 0;
    uAddedColorG = 0;
    uAddedColorB = 0;

    standartMax = 0.8;
    uAddedColorRMax = 0.8;
    uAddedColorGMax = 0.4;
    uAddedColorBMax = 0.3;

    glowTimerAll = 25;

    glowTimers = {

    };

    lastFrameX = 0;
    lastFrameY = 0;

    init = () => {

        const canvas = document.getElementById(`textCrop_${this.uId}`)
        const {
            width,
            height,
            textureUrl
        } = this.props;

        this.renderer = new THREE.WebGLRenderer({
            canvas,
            alpha: true,
            antialias: true
        });

        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(width, height);
        // this.renderer.setPixelRatio(window.devicePixelRatio * 3);

        this.scene = new THREE.Scene();

        this.camera = new THREE.PerspectiveCamera(50, width / height, 1, 1000);
        this.camera.position.z = 500;
        this.scene.add(this.camera);

        const loader = new THREE.TextureLoader();
        loader.load(textureUrl, this.textureLoaded);
    }

    textureLoaded = (texture) => {
        const {
            width,
            height,
            allFramesX,
            allFramesY,
            frameY, frameX,
            HtoW
        } = this.props;

        const WtoHScreen = width / height;
        // при spriteH = 465 и  в экран укладывается ровно 1 штука
        const spriteH = 465;

        const { spriteHeight, spriteTop, spriteLeft } = this.props;
        const spriteWidth = spriteHeight * HtoW;

        const HtoPxKoef = spriteH / height; // это надо умножить на нужные пиксели
        const spriteToHeight = HtoPxKoef * spriteHeight;

        const startYOffset = (spriteH / 2) - (HtoPxKoef * spriteHeight / 2);
        const startXOffset = -((spriteH / 2) * WtoHScreen) + (HtoPxKoef * spriteWidth / 2);



        this.testMaterial = new THREE.ShaderMaterial({
            depthWrite: false,
            blending: THREE.AdditiveBlending,
            vertexColors: true,
            vertexShader: `
                  precision mediump float;
                  varying vec2 vUv;

                  void main() {
                        vUv = uv;
                        vec3 tref = vec3( 
                            position.x,
                            position.y,
                            position.z
                        );
                        gl_Position = projectionMatrix * modelViewMatrix * vec4(tref, 1.0);

                  }
                `,
            fragmentShader: `
                  precision mediump float;

                  uniform sampler2D uTexture;
                  uniform float uXFrame;
                  uniform float uYFrame;

                  uniform float uXLastFrame;
                  uniform float uYLastFrame;

                  uniform float uYAllFrames;
                  uniform float uOneFrameWidth;
                  uniform float uOneFrameHeight;
                  uniform float uAddedColorR;
                  uniform float uAddedColorG;
                  uniform float uAddedColorB;

                  varying vec2 vUv;

                  void main() {
                    vec2 tref = vec2(  
                        uXFrame * uOneFrameWidth + (vUv.x * uOneFrameWidth),
                        (uYAllFrames - uYFrame - 1.0) * uOneFrameHeight + (vUv.y * uOneFrameHeight)
                    );

                    
                    gl_FragColor = texture2D(uTexture, tref);

                    // if (gl_FragColor.w == 0.0) {
                    //         vec2 trefPrev = vec2(  
                    //             uXLastFrame * uOneFrameWidth + (vUv.x * uOneFrameWidth),
                    //             (uYAllFrames - uYLastFrame - 1.0) * uOneFrameHeight + (vUv.y * uOneFrameHeight)
                    //         );
                    //         vec4 lastFrame = texture2D(uTexture, trefPrev);
                    //         gl_FragColor = lastFrame;
                    // }

                    gl_FragColor.x += uAddedColorR;
                    gl_FragColor.y -= uAddedColorR;
                    gl_FragColor.z -= uAddedColorR;

                    
                    gl_FragColor.x -= uAddedColorG;
                    gl_FragColor.y += uAddedColorG;
                    gl_FragColor.z -= uAddedColorG;

                    
                    gl_FragColor.x -= uAddedColorB;
                    gl_FragColor.y -= uAddedColorB;
                    gl_FragColor.z += uAddedColorB;

                  }
                `,

            uniforms: {
                uTime: { value: 0 },
                uXFrame: { value: frameX },
                uYFrame: { value: frameY },

                uXLastFrame: { value: frameX },
                uYLastFrame: { value: frameX },

                uXLeft: { value: spriteLeft },

                uAddedColorR: { value: 0 },
                uAddedColorG: { value: 0 },
                uAddedColorB: { value: 0 },

                uYAllFrames: { value: allFramesY },
                uOneFrameWidth: { value: 1 / allFramesX },
                uOneFrameHeight: { value: 1 / allFramesY },
                uTexture: { value: texture },
            }
        })

        this.sprite = new THREE.Sprite(this.testMaterial);

        this.startXOffset = startXOffset;
        this.HtoPxKoef = HtoPxKoef;

        this.sprite.scale.set(spriteToHeight * HtoW, spriteToHeight, 0)
        this.sprite.position.set(startXOffset + HtoPxKoef * spriteLeft, startYOffset - HtoPxKoef * spriteTop, 0);
        this.scene.add(this.sprite);

        this.tick();
    }

    // анимация хита
    hitted = () => {
        this.glowTimers['uAddedColorR'] = this.glowTimerAll;
    }
    heal = () => {
        this.glowTimers['uAddedColorG'] = this.glowTimerAll;
    }
    cold = () => {
        this.glowTimers['uAddedColorB'] = this.glowTimerAll;
    }
    tick = () => {

        const timers = Object.keys(this.glowTimers);
        for (let i = 0; i < timers.length; i++) {
            const key = timers[i];
            if (this.glowTimers[key] > 0) {
                let spend;
                if (this.glowTimers[key] > (this.glowTimerAll / 2)) {
                    spend = (this.glowTimerAll) - this.glowTimers[key];
                    spend = spend / (this.glowTimerAll / 2);
                } else {
                    spend = this.glowTimers[key];
                    spend = spend / (this.glowTimerAll / 2);
                }

                this[key] = (this[`${key}Max`] || this.standartMax) * spend;
                this.glowTimers[key]--;
            }

            if (this.glowTimers[key] <= 0 && this[key] !== 0) {
                this[key] = 0;
            }
        }

        if (this.sprite.material.uniforms.uAddedColorR.value !== this.uAddedColorR)
            this.sprite.material.uniforms.uAddedColorR.value = this.uAddedColorR;

        if (this.sprite.material.uniforms.uAddedColorG.value !== this.uAddedColorG)
            this.sprite.material.uniforms.uAddedColorG.value = this.uAddedColorG;

        if (this.sprite.material.uniforms.uAddedColorB.value !== this.uAddedColorB)
            this.sprite.material.uniforms.uAddedColorB.value = this.uAddedColorB;
        this.renderer.render(this.scene, this.camera);
        window.requestAnimationFrame(this.tick)
    }

    componentDidMount = () => {
        this.init();
    }

    componentDidUpdate = () => {
        if (!this.testMaterial) return;
        const { frameX, frameY, spriteLeft } = this.props;

        // this.lastFrameX = this.testMaterial.uniforms.uXFrame.value;
        // this.lastFrameY = this.testMaterial.uniforms.uYFrame.value;

        this.testMaterial.uniforms.uXFrame.value = frameX;
        this.testMaterial.uniforms.uYFrame.value = frameY;

        // this.testMaterial.uniforms.uXLastFrame.value = this.lastFrameX;
        // this.testMaterial.uniforms.uYLastFrame.value = this.lastFrameY;

        this.sprite.position.x = this.startXOffset + this.HtoPxKoef * spriteLeft

        // this.renderer.render(this.scene, this.camera);
    }

    render() {
        const { width, height, top = 0, left = 0, zIndex = 1 } = this.props;
        return <canvas style={{
            position: 'absolute',
            top, left,
            width, height,
            zIndex,
            background: 'none'
        }} id={`textCrop_${this.uId}`}></canvas>
    }

}